<template>
  <div :class="$style.base">
    <div :class="$style.inner">
      <ChooseDate @submit="$emit('submit')" @back="$emit('back')" />
    </div>
    <RescheduleConfirmation
      v-if="widgetSettings.bookingId"
      @submit="$emit('submit')"
    />
  </div>
</template>

<script setup lang="ts">
import { useBookingStore } from '@/stores/booking';
import widgetSettings from '@/widget-settings';
import ChooseDate from './ChooseDate.vue';
import RescheduleConfirmation from './RescheduleConfirmation.vue';

defineOptions({ name: 'ChooseDate' });
const emit = defineEmits(['submit', 'back']);

// When going back to this step, the waiting list flow needs to be reset
const bookingStore = useBookingStore();
bookingStore.waitingList = false;
</script>

<style lang="scss" module>
.base {
  display: flex;
  flex-direction: column;
  background-color: $color-bg;
}

.inner {
  @include page;
}

.chooseEmployee {
  text-align: center;
  padding: $spacing;
}
</style>
